import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiAlertTriangle } from 'react-icons/fi';
import styles from './PermissionsChangedBanner.module.scss';

const PermissionsChangedBanner: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <span className={styles.icon}>
                <FiAlertTriangle />
            </span>
            <span className={styles.message}>
                {t('common.permissions_changed_message')}
            </span>
        </div>
    );
};

export default PermissionsChangedBanner;
